import styled from 'styled-components';
import { fadeIn } from '../../../constants/keyframes/fades';
import { media } from '../../../constants/media/media';
import theme from '../../../constants/theme';
import zIndex from '../../../constants/zIndex';
import { Column, Columns } from '../../base/grid';
import { A, P } from '../../base/typography';

export const Wrapper = styled.div`
	background-color: white;
	padding: 3rem;
	max-height: 100%;
	min-width: 60rem;
	max-width: 100%;
	overflow: auto;

	@media screen and (max-width: 60rem) {
		min-width: 0;
	}

	input {
		margin-bottom: 1rem;
	}

	button {
		float: right;
		margin-top: 3rem;
	}

	label {
		color: ${theme.colors.black};
	}

	${({ large }) =>
		large &&
		`
		height: 80vh;
	`}

	${media.mobileOnly`
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;

        button { width: 100%; }
    `}

	${({ red }) =>
		red &&
		`
        background-color: ${theme.colors.primary};
        color: white;
	    padding: 2rem;
	    min-width: 0;

	    button {
            float: left;
	        margin: 1rem 1rem 0 0;
	        :last-child { margin-right: 0; }
	    }
    `}
`;

export const CenterWrapper = styled.div`
	min-height: 80%;
	display: grid;
	place-items: center;

	div {
		text-align: center;
		p {
			color: ${({ theme }) => theme.colors.primary};
		}
	}

	strong {
		font-family: ${({ theme }) => theme.fonts.ArimoBold};
	}
`;

export const FullHeightColumns = styled(Columns)`
	height: 100%;
`;

export const DeliveryOptionsWrapper = styled(Column)`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	height: 100%;
	margin: 0;

	> div {
		width: 100%;
	}
`;

export const WrapperRight = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	width: 50rem;
	height: 100%;
	z-index: 100;
	background: white;
	padding: 3rem 4rem;
	overflow: auto;

	${media.mobileOnly`
        width: 100%;
    `}
`;

export const Heading = styled.span`
	display: flex;
	justify-content: space-between;
	margin-bottom: 3rem;
	font-size: 2.5rem;
	font-weight: bold;
	color: ${theme.colors.black};
	svg {
		fill: ${theme.colors.primary};
	}

	div a {
		display: flex;
		align-items: center;
		font-size: 1.8rem;
		color: ${theme.colors.gray};
		svg {
			margin-right: 0.6rem;
		}
	}

	${media.tablet`
        && > a { display: none; }
    `}

	${({ right }) =>
		right &&
		`
        margin: 0;
        && > a { display: inline; }
    `}
`;

export const CheckboxWrapper = styled.div`
	margin: 1rem 0;
	label {
		margin-top: 0.5rem;
	}
`;

export const FamilyMembersWrapper = styled.div`
	${({ hide }) =>
		hide &&
		`
       display: none;
    `}
`;

export const CardWrapper = styled.div`
	background-color: white;
	border: 1px solid ${theme.colors.grayLighter2};
	box-shadow: 0px 11px 24px #ececec;
	margin: 2rem 0;

	${({ highlight }) =>
		highlight &&
		`
		border: 1px solid ${theme.colors.secondary};
	`}

	${({ primaryHighlight }) =>
		primaryHighlight &&
		`
		border: 1px solid ${theme.colors.primary};
	`}

	${({ grayHighlight }) =>
		grayHighlight &&
		`
		border: 1px solid ${theme.colors.gray};
	`}

	${({ old }) =>
		old &&
		`
		background-color: #f1f1f1;
		border: 1px solid #e1e1e1;
		div {
			border-color: #e1e1e1;
		}
    `}
`;

export const CardHeading = styled.div`
	font-weight: bold;
	color: ${theme.colors.black};
	display: flex;
	justify-content: space-between;

	div:last-child {
		color: ${theme.colors.secondary};
	}
`;

export const CardSubHeading = styled.div`
	color: ${theme.colors.primary};
`;

export const CardLink = styled(A)`
	display: block;
	background-color: white;
	color: ${theme.colors.black};
	margin-bottom: 2rem;
	padding: 1rem 2rem;

	font-family: ${theme.fonts.ArimoRegular};
	color: ${theme.colors.gray};
	:hover {
		color: ${theme.colors.gray};
	}

	${({ highlight }) =>
		highlight &&
		`
		cursor: default;
    `}
`;

export const CardFooter = styled.a`
	margin-top: 2rem;
	padding: 0.5rem;
	display: block;
	background-color: ${theme.colors.secondary};
	color: white;
	text-align: center;
	cursor: pointer;

	:hover {
		background-color: ${theme.colors.secondaryDark};
		color: white;
	}

	${({ disabled }) =>
		disabled &&
		`
		cursor: default;
		pointer-events: none;
	`}
`;

export const MapContainer = styled.div`
	height: 50vh;
	width: 70vh;

	${media.mobileOnly`
        width: 100%;
        height: 85%;
    `}
`;

export const NotificationsEmpty = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	font-size: 2rem;
`;

export const NotificationHeading = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 2rem 3rem;
	color: ${theme.colors.gray};
	font-size: 1.6rem;

	div:first-child {
		display: flex;
		align-items: center;
		font-weight: bold;
		font-size: 1.8rem;
		color: ${theme.colors.black};
	}

	svg {
		width: auto;
		max-height: 2rem;
		margin-right: 1.5rem;
	}
`;

export const NotificationDetails = styled.div`
	padding: 0rem 3rem 2rem;
	font-size: 1.8rem;

	strong {
		font-weight: normal;
		color: ${theme.colors.secondary};
	}
`;

export const NotificationCallToAction = styled.div`
	padding: 2rem 3rem;
	border-top: 1px solid ${theme.colors.grayLighter2};
	text-align: right;
	font-size: 1.6rem;
	svg {
		width: auto;
		max-height: 2rem;
		margin-right: 1rem;
		path {
			fill: ${theme.colors.primary};
		}
	}
`;

export const InputWrapper = styled.div`
	display: flex;
	border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};

	${media.mobileOnly`
		display: block;
	`};
`;

export const SelectWrapper = styled.div`
	cursor: pointer;
	font-size: 2rem;
	${media.tablet`
        font-size: 1.7rem;
    `};
`;

export const SearchInput = styled.input`
	width: 100%;
	padding: 2.4rem 0 2.4rem 1rem;
	font-size: 2rem;

	${media.tablet`
		padding: 2.4rem;
        font-size: 1.8rem;
	`};
`;

export const SearchInputWrapper = styled.div`
	position: relative;
	width: 100%;

	svg {
		position: absolute;
		top: 50%;
		right: 4rem;
		transform: translateY(-50%);
		color: ${({ theme }) => theme.colors.primary};
		pointer-events: none;
	}

	${media.mobileOnly`
		border-top: 1px solid ${({ theme }) => theme.colors.borderColor};
	`};
`;

export const MapWrapper = styled.div`
	height: calc(100% + 3rem);
	margin-top: -1.5rem;
	margin-bottom: -1.5rem;
	margin-right: -1.5rem;
	${media.mobileAndTabletOnly`
		display: none;
		margin: 0;
	`};
`;

export const StyledColumn = styled(Column)`
	margin: -12px 0px;
	padding-right: 0px;
`;

export const ErrorMessage = styled.div`
	border: 1px solid ${theme.colors.primaryDark};
	padding: 1rem 2rem;
	font-size: 1.4rem;
	margin: 0 0 1.5rem 0;
	color: ${theme.colors.primaryDark};
	display: flex;
	justify-content: center;

	svg {
		display: block;
		margin-right: 1rem;
		height: 2rem;
		width: 2rem;
	}
`;

export const UploadWrapper = styled.div`
	margin-bottom: 2rem;
`;

export const SvgWrapper = styled.div`
	svg {
		max-width: 100%;
		display: block;
		margin: 0 auto;
	}
`;

export const InfoContainer = styled(P)`
	margin-top: 2rem;
	width: 100%;
	max-width: 50rem;
`;

export const ModalForm = styled.div`
	${media.desktopSmall`
		max-width: 60vw;
	`};
	${media.desktopLarge`
		max-width: 40vw;
	`};
`;

export const WrapperV2 = styled.div`
	padding: 3rem;
	max-height: 100%;
	min-width: 60rem;
	max-width: 100%;

	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: auto;
	width: 100%;
	height: 100%;
	z-index: ${zIndex.modals};

	@media screen and (max-width: 60rem) {
		min-width: 0;
	}

	input {
		margin-bottom: 1rem;
	}

	button {
		float: right;
		margin-top: 3rem;
	}

	label {
		color: ${theme.colors.black};
	}

	${({ large }) =>
		large &&
		`
		height: 80vh;
	`}

	${media.mobileOnly`
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;

        button { width: 100%; }
    `}

	${({ red }) =>
		red &&
		`
        background-color: ${theme.colors.primary};
        color: white;
	    padding: 2rem;
	    min-width: 0;

	    button {
            float: left;
	        margin: 1rem 1rem 0 0;
	        :last-child { margin-right: 0; }
	    }
    `}
`;

export const ModalOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: -1;
	background-color: rgba(0, 0, 0, 0.6);
	animation: ${fadeIn} 300ms ease;
`;

export const WhiteBox = styled.div`
	background-color: white;
	padding: 2rem 3rem;
	border-radius: 0;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
	position: relative;
	width: 100%;
	max-width: 50rem;
	box-sizing: border-box;
`;

export const CloseButton = styled.button`
	position: absolute;
	top: -2rem;
	right: 1rem;
	background: transparent;
	border: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;

	svg {
		width: 1.6rem;
		height: 1.6rem;
		color: ${({ theme }) => theme.colors.gray};
	}

	:hover svg {
		color: ${({ theme }) => theme.colors.black};
	}
`;

export const ModalHeader = styled.div`
	text-align: center;
	font-size: 2rem;
`;

export const ModalActions = styled.div`
	display: flex;
	justify-content: flex-end;
	flex-wrap: wrap;
	gap: 1rem;
	margin-top: 2rem;

	button {
		flex: 1 1 auto; // allow button to shrink and wrap
		min-width: 8rem; // optional, ensures they don't get too small
	}

	@media (max-width: 480px) {
		flex-direction: column;
		align-items: stretch;

		button {
			width: 100%;
		}
	}
`;
